import {http} from "../config/Constantes";

export default class TarefaService {
    listSolicitacoes() {
        return http.get("/tarefa/usuario")
    }

    listSolicitacoesPorUsuario() {
        return http.get("/tarefa/usuario")
    }

    listSolicitacoesEmAndamento() {
        return http.get("/solicitacao/pendentes/")
    }

    listHorasExtrasPendentes() {
        return http.get("/timesheet")
    }

    tramitar(id, tipoFluxo, idSolicitacao, outcome, razao, comentario, detalhesTarefa, listaAprovadores = []) {
        return http.post("/tarefa/tramitar", {idTarefaBpm: id, tipoFluxo: tipoFluxo, idSolicitacao: idSolicitacao, outcome: outcome, razao: razao, comentario: comentario, detalhesTarefa: detalhesTarefa, listaAprovadores: listaAprovadores});
    }

    tramitarEmLote(acoesTarefaBpm) {
        return http.post("/tarefa/tramitar/lote", acoesTarefaBpm)
    }

    iniciarFluxoSubstituicao(solicitacaoSubstituicao) {
        return http.post("/substituicao", solicitacaoSubstituicao)
    }

    enviar(id, tipoFluxo, idSolicitacao, comentario, detalhesTarefa, listaAprovadores = []) {
        return http.post("/tarefa/tramitar", {
            idTarefaBpm: id,
            outcome: "ENVIAR",
            tipoFluxo: tipoFluxo,
            idSolicitacao: idSolicitacao,
            comentario: comentario,
            detalhesTarefa: detalhesTarefa,
            listaAprovadores: listaAprovadores
        })
    }

    getComentarios(tipoFluxo, idSolicitacao){
        return http.get("/tarefa/comentarios/"+ tipoFluxo + "/"+idSolicitacao);
    }

    getTarefasFluxo(tipoFluxo){
        const taskIdBpm = window.location.href.includes("?id=") ? window.location.href.split("?id=")[1] : window.location.href.split("/").slice(-1)[0];
        if(taskIdBpm && taskIdBpm !== "")
            return http.get("/tarefa/tarefasFluxo/"+ tipoFluxo + "/" + taskIdBpm);
        else
            //tratamento para não quebrar o detalhamento da prorrogação e término antecipado
            return Promise.resolve(null); 
    }

    delegar(listaTarefas, loginUsuario) {
        return http.post("/tarefa/delegar", { listIdsTarefas: listaTarefas, usuarioParaAssumir: loginUsuario});
    }

    deletar(litaPradeletear, observacao){
        return http.post("/tarefa/cancelar", { listCancelamento: litaPradeletear, observacao: observacao});
    }

    forcarAprovacao(tipoFluxo, idSolicitacao, comentario){
        return http.post("/tarefa/forcar-aprovacao", { tipoFluxo: tipoFluxo, idSolicitacao: idSolicitacao, outcome: "FORCE_APPROVE", comentario: comentario});
    }

    //RHFPP-612 - Atualizar Gestor Solicitante
    atualizarGestorSolicitacao(idSolicitacao, emailGestor){
        const listSolicitacoes = [idSolicitacao];
        return http.post("/tarefa/forced/atualizar-gestor", {"solicitacaoIds": listSolicitacoes, "emailNovoGestor": emailGestor})
    }
    //RHFPP-2370-PocTimesheet
    listHorasTrabalhadasPendentes() {
        return http.get("/timesheet/tarefas-pendentes/")
    }
    delegarV2(listaTarefas, loginUsuario) {
        //return http.post("/tarefa/delegar", { listIdsTarefas: listaTarefas, usuarioParaAssumir: loginUsuario});
        return http.post("/tarefa/v2/delegar", { listIdsTarefas: listaTarefas, usuarioParaAssumir: loginUsuario});
    }
}